export const languageOptions = [
    { id: "1", text: 'en' },
    { id: "2", text: 'fr' },
    { id: "3", text: 'nl' },
    { id: "4", text: 'de' }
];

const en = {
    "logout": "Logout",
    "Welcome": "Welcome",
    "Login": "Login",
    "welcomeline1": "Welcome to MyConcession",
    "welcomeline2": "Click below to login",
    "IECompatabilityMessage": "It is possible that certain functionalities may not be available on this browser, we invite you to use a more recent browser.",
    "password_reset": "Forgot your password ?",
    "click_here": "Click Here",
    "bKeyHelp": "How to create B-Key for login into the MyConcessions application.",
    "cookieSettings": "Cookie settings",
    "cookiesMessage": "We use only strictly necessary cookies. These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not work anymore.",
    "discontinued-msg-1": "From 01/05/2026 this application is discontinued",
    "discontinued-msg-2": "For additional information",
    "contact-account-manager": "contact your account manager",
    "send-email-text": "send an email to ",
    "email-id": "23.omzetcijfers-chiffresdaffaires@belgiantrain.be"
}

const fr = {
    "logout": "Se déconnecter",
    "Welcome": "BIENVENUE",
    "Login": "S'identifier",
    "welcomeline1": "Bienvenue à MyConcession",
    "welcomeline2": "Cliquez ci-dessous pour vous logger",
    "IECompatabilityMessage": "Il est possible que certaines fonctionnalités ne soient pas disponibles sur ce navigateur, nous vous invitons à utiliser un navigateur plus récent.",
    "password_reset": "Oublié votre mot de passe ?",
    "click_here": "Cliquez ici",
    "bKeyHelp": "Comment créer B-Key pour se connecter à l'application MyConcessions.",
    "cookieSettings": "Paramètres des cookies",
    "cookiesMessage": "Nous n'utilisons que des cookies strictement nécessaires. Ces cookies sont nécessaires au fonctionnement de l'application et ne peuvent donc pas être désactivés dans nos systèmes.Ils sont généralement définis en réponse à certaines actions de l'utilisateur, telles que la soumission d'une demande ou la définition de ses préférences de confidentialité ou la connexion et/ou le remplissage de formulaires. Vous pouvez modifier les paramètres de votre navigateur afin que ces cookies soient bloqués ou que vous receviez un avertissement. Par conséquent, certaines parties de l'application peuvent ne plus fonctionner comme prévu.",
    "discontinued-msg-1": "À partir du 01/05/2026, cette application est arrêtée",
    "discontinued-msg-2": "Pour plus d'informations",
    "contact-account-manager": "contactez votre gestionnaire de compte",
    "send-email-text": "envoyez un e-mail à ",
    "email-id": "23.omzetcijfers-chiffresdaffaires@belgiantrain.be"
}

const nl = {
    "logout": "Uitloggen",
    "Welcome": "Welkom",
    "Login": "Aanmelden",
    "welcomeline1": "Welkom bij Myconcession",
    "welcomeline2": "klik hieronder om u aan te melden",
    "IECompatabilityMessage": "Mogelijk zijn bepaalde functionaliteiten niet beschikbaar in deze browser, we nodigen u uit om een recentere browser te gebruiken.",
    "password_reset": "Wachtwoord vergeten ?",
    "click_here": "Klik hier",
    "bKeyHelp": "Hoe u een B-Key aanmaakt om in te loggen in de MyConcessions-applicatie.",
    "cookieSettings": "Cookie instellingen",
    "cookiesMessage": "Wij gebruiken enkel strikt noodzakelijke cookies. Deze cookies zijn noodzakelijk om de applicatie te laten functioneren en kunnen niet worden uitgeschakeld in onze systemen.Ze worden meestal alleen ingesteld naar aanleiding van bepaalde acties van een gebruiker zoals het indienen van een verzoek of het instellen van uw privacy voorkeuren of het inloggen en/of het invullen van formulieren. U kunt uw browser instellen wijzigen zodat deze cookies geblokkeerd worden of u een waarschuwing krijgt. Hierdoor kunnen sommige onderdelen van de applicatie niet meer werken zoals voorzien.",
    "discontinued-msg-1": "Vanaf 01/05/2026 is deze applicatie stopgezet",
    "discontinued-msg-2": "Voor meer informatie",
    "contact-account-manager": "neem contact op met uw accountmanager",
    "send-email-text": "stuur een e-mail naar ",
    "email-id": "23.omzetcijfers-chiffresdaffaires@belgiantrain.be"
}

const de = {
    "logout": "Ausloggen",
    "Welcome": "herzlich willkommen",
    "Login": "Anmeldung",
    "welcomeline1": "Willkommen bei MyConcession",
    "welcomeline2": "klicken Sie unten, um sich anzumelden",
    "IECompatabilityMessage": "Es ist möglich, dass bestimmte Funktionen in diesem Browser nicht verfügbar sind. Wir laden Sie ein, einen neueren Browser zu verwenden.",
    "password_reset": "Passwort vergessen ?",
    "click_here": "Klicken Sie hier",
    "bKeyHelp": "So erstellen Sie einen B-Key für die Anmeldung bei der MyConcessions-Anwendung.",
    "cookieSettings": "Cookie settings",
    "cookiesMessage": "We use only strictly necessary cookies. These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not work anymore.",
    "discontinued-msg-1": "Ab dem 01.05.2026 wird diese Anwendung eingestellt",
    "discontinued-msg-2": "Für weitere Informationen",
    "contact-account-manager": "Kontaktieren Sie Ihren Account Manager",
    "send-email-text": "senden Sie eine E-Mail an ",
    "email-id": "23.omzetcijfers-chiffresdaffaires@belgiantrain.be"
}
export const labelsList = {
    en,
    fr,
    nl,
    de
}
